/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'cookie-utils',
    'pip-events',
    'window',
    '@thd-olt-global/thd-customer'
  ],
  function (
    $,
    pip,
    cookieUtils,
    pipEvents,
    window,
    thdCustomer
  ) {
    var baseUrl;
    var cookie;


    function getItemsCall( itemIds ) {
      if(!baseUrl) {
        baseUrl = buildUrl();
      }
      var itemsUrl = baseUrl + "items/inCpo?itemids=" + itemIds.toString() + "&includePending=True";
      return $.ajax(
        {
          headers: {
            'Content-Type': 'application/json',
          },
          contentType: "application/json",
          dataType:'json',
          method: "GET",
          xhrFields: {
            withCredentials: true
          },
          url: itemsUrl,
          error: function(err) {
            if (typeof window.newrelic === 'object' && window.newrelic.noticeError && window.newrelic.addPageAction) {
              window.newrelic.addPageAction('CPOError', {
                'errorSourceFile': 'custom-product-offering',
                'errorType': 'AjaxError',
                'errorStatus': err.status
              });
              window.newrelic.noticeError('Error calling b2b-cpo-service in custom-product-offering');
            }
          }
        }
      );
    }

    function buildUrl() {
      if (pip.features.thdCustomerCookieEnabled) {
        baseUrl = "/b2b/cpo/v1/" + thdCustomer.default.svocID + "/" + thdCustomer.default.userID + "/cpo/";
      } else {
        cookie = cookieUtils.parseJWTCookie('THD_CUSTOMER');
        baseUrl = "/b2b/cpo/v1/" + cookie.t + "/" + cookie.u + "/cpo/";
      }
      return baseUrl;
    }

    function getCustomCatalogItemIds (collectionIds) {
      getItemsCall(collectionIds).then(function (response) {
        var cpoData = {
          itemIds: [],
          isPending: false
        };
        if(response.includedItemIds)
          cpoData.itemIds = response.includedItemIds;
        if(response.isCpoPending)
          cpoData.isPending = true;
        pipEvents.customProductOffering.irgItemsReceived.trigger(cpoData);
      });
    }

    return {

      init: function () {
          getItemsCall(pip.products.primary.data.itemId).then(function (cpoResponse) {
          var cpoData = {
            cpoId: cpoResponse.cpoId,
            inCpo: false,
            isPending: false,
            cookie: cookie
          };
          if (cpoResponse.includedItemIds.length !== 0) {
            cpoData.inCpo = true;
          }
          if(cpoResponse.isCpoPending){
            cpoData.isPending = true;
          }
          pipEvents.customProductOffering.cpoInfoReceived.trigger(cpoData);
        })
      },
      getCustomCatalogItemIds : getCustomCatalogItemIds
      }
  });

}.call(window));